<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a [routerLink]="['/admin/riders']">Partners</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Summary</span></li>
                    </ol>
                </div>
                <div class="partners-head">
                    <div class="content-title">
                        <h2>Partners</h2>
                    </div>
                    <div class="partners-head-actions">
                        <label for="asOf">As of</label>
                        <div class="calendar">
                            <input type="date" id="asOf" class="text-calendar"
                                   [(ngModel)]="asOf" (ngModelChange)="onAsOfChange()">
                            <img src="../../../../assets/okito/images/calendar.svg">
                        </div>
                    </div>
                </div>
                <hr>
                <div class="list-tabs">
                    <ul>
                        <li><a [routerLink]="['/admin/riders']">Partner List</a></li>
                        <li class="active"><a [routerLink]="['/admin/partners-summary']">Summary</a></li>
                    </ul>
                </div>

                <ng-container *ngIf="loadFailed; else summaryBody">
                    <div class="empty-state" *ngIf="apiUnsupported; else summaryLoadError">
                        <img src="../../../../assets/okito/images/empty.svg" alt="">
                        <h4>Not available on this environment yet.</h4>
                        <p>
                            The Partners summary needs an API release that this environment doesn't
                            have. The Partner List tab works in the meantime.
                        </p>
                        <a [routerLink]="['/admin/riders']" class="btn btn-sm btn-default">Go to Partner List</a>
                    </div>
                    <ng-template #summaryLoadError>
                        <div class="empty-state">
                            <img src="../../../../assets/okito/images/empty.svg" alt="">
                            <h4>Connection not available.</h4>
                            <p>We couldn't load the partner summary. Please try again.</p>
                            <a href="#" class="btn btn-sm btn-default" (click)="reload($event)">Try again</a>
                        </div>
                    </ng-template>
                </ng-container>

                <ng-template #summaryBody>
                    <p class="summary-intro">
                        Registration pipeline and approved partner mix · As of {{ asOfLabel }}
                    </p>

                    <!-- Registration pipeline: each partner sits in one stage only -->
                    <section class="pipeline">
                        <h5 class="pipeline-title">
                            Registration pipeline
                            <span class="info-tip">
                                <button type="button" class="info-tip-btn" aria-label="About the registration pipeline"><i class="fa fa-info-circle"></i></button>
                                <span class="info-tip-box" role="tooltip">Where every registered partner currently sits in onboarding. Each partner appears in exactly one stage, and the stages add up to the total. Partners who signed up after the selected date are left out; everyone else is counted by the status they hold today.</span>
                            </span>
                        </h5>
                        <div class="pipeline-cards">
                            <div class="pipeline-card" *ngFor="let card of pipelineCards"
                                 [class.is-active]="card.active">
                                <small>
                                    {{ card.label }}
                                    <span class="info-tip" [class.info-tip-r]="card.active">
                                        <button type="button" class="info-tip-btn" [attr.aria-label]="'About ' + card.label"><i class="fa fa-info-circle"></i></button>
                                        <span class="info-tip-box" role="tooltip">{{ card.hint }}</span>
                                    </span>
                                </small>
                                <h4>{{ pipeline[card.key] | number }}</h4>
                                <img [src]="'../../../../assets/okito/images/card-icons/' + card.icon" alt="">
                            </div>
                        </div>
                    </section>

                    <!-- Approved by service: a partner can hold several services, so counts overlap -->
                    <section class="breakdown">
                        <div class="breakdown-head">
                            <h4>
                                Approved partners by service
                                <span class="info-tip">
                                    <button type="button" class="info-tip-btn" aria-label="About approved partners by service"><i class="fa fa-info-circle"></i></button>
                                    <span class="info-tip-box" role="tooltip">A partner can be approved for more than one service, so these counts overlap and won't add up to {{ pipeline['approved'] | number }}. “% of approved” is the share of all {{ pipeline['approved'] | number }} approved partners who hold that service.</span>
                                </span>
                            </h4>
                            <span class="breakdown-pill">Counts overlap · not headcount</span>
                        </div>
                        <div class="svc-cards">
                            <div class="svc-card" *ngFor="let service of byService">
                                <div class="svc-card-top">
                                    <span class="svc-card-veh">{{ vehicleLabel(service.vehicleClass) }}</span>
                                    <img [src]="'../../../../assets/okito/images/card-icons/' + serviceIcon(service.key)" alt="">
                                </div>
                                <div class="svc-card-name">
                                    <h5>{{ serviceName(service.key) }}</h5>
                                    <small>{{ serviceSubtitle(service.key) }}</small>
                                </div>
                                <div class="svc-card-count">
                                    <h4>{{ service.count | number }}</h4>
                                    <small>{{ service.shareOfApproved | percent: '1.1-1' }} of approved</small>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Approved by vehicle: each partner counted once, cards add up to the approved total -->
                    <section class="breakdown">
                        <div class="breakdown-head">
                            <h4>
                                Approved partners by vehicle
                                <span class="info-tip">
                                    <button type="button" class="info-tip-btn" aria-label="About approved partners by vehicle"><i class="fa fa-info-circle"></i></button>
                                    <span class="info-tip-box" role="tooltip">Each partner is counted once, by registered vehicle, so the cards add up to {{ pipeline['approved'] | number }}. Rows inside a card don't overlap and add up to that card's total. “Express only” means approved for Express and nothing else.</span>
                                </span>
                            </h4>
                            <span class="breakdown-pill breakdown-pill-sum">
                                Each partner once · adds up to {{ pipeline['approved'] | number }}
                            </span>
                        </div>
                        <div class="veh-cards">
                            <div class="veh-card" *ngFor="let vehicle of byVehicle">
                                <div class="veh-card-head">
                                    <h5>
                                        <img [src]="'../../../../assets/okito/images/card-icons/' + vehicleIcon(vehicle.vehicleClass)" alt="">
                                        {{ vehicleLabel(vehicle.vehicleClass) }}
                                    </h5>
                                    <h4>{{ vehicle.total | number }}</h4>
                                </div>
                                <ul class="veh-card-rows">
                                    <li *ngFor="let row of vehicle.rows">
                                        <span><i class="veh-dot" [ngClass]="mixDot(row.key)"></i>{{ mixLabel(row.key) }}</span>
                                        <strong>{{ row.count | number }}</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </section>
                </ng-template>
            </div>
        </div>
    </div>
</div>
